export default "__VITE_ASSET__1e7b91b5__"